module.exports = __webpack_public_path__ + "static/img/head-logo-light.95fc4e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/head-logo-light.png
// module id = 303
// module chunks = 4